export const Facebook = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12.709C22 7.18598 17.523 2.70898 12 2.70898C6.477 2.70898 2 7.18598 2 12.709C2 17.7 5.657 21.837 10.438 22.587V15.6H7.898V12.709H10.438V10.506C10.438 7.99998 11.93 6.61598 14.215 6.61598C15.309 6.61598 16.453 6.81098 16.453 6.81098V9.27098H15.193C13.95 9.27098 13.563 10.042 13.563 10.833V12.709H16.336L15.893 15.599H13.563V22.587C18.343 21.837 22 17.7 22 12.709Z"
      fill="#9CA3AF"
    />
  </svg>
);

export const Instagram = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.315 2.70898C14.745 2.70898 15.099 2.72198 16.123 2.76898C17.187 2.81798 17.914 2.98698 18.55 3.23398C19.2175 3.48486 19.8222 3.87834 20.322 4.38698C20.8306 4.88676 21.2241 5.49149 21.475 6.15898C21.722 6.79498 21.891 7.52198 21.94 8.58598C21.988 9.65298 22 9.99298 22 12.709V12.789C22 15.432 21.988 15.776 21.94 16.832C21.891 17.896 21.722 18.623 21.475 19.259C21.2241 19.9265 20.8306 20.5312 20.322 21.031C19.8222 21.5396 19.2175 21.9331 18.55 22.184C17.914 22.431 17.187 22.6 16.123 22.649C15.056 22.697 14.716 22.709 12 22.709H11.92C9.277 22.709 8.933 22.697 7.877 22.649C6.813 22.6 6.086 22.431 5.45 22.184C4.7825 21.9331 4.17777 21.5396 3.678 21.031C3.16936 20.5312 2.77587 19.9265 2.525 19.259C2.278 18.623 2.109 17.896 2.06 16.832C2.013 15.808 2 15.453 2 13.024V12.394C2 9.96398 2.013 9.60998 2.06 8.58598C2.109 7.52198 2.278 6.79498 2.525 6.15898C2.77587 5.49149 3.16936 4.88676 3.678 4.38698C4.17777 3.87834 4.7825 3.48486 5.45 3.23398C6.086 2.98698 6.813 2.81798 7.877 2.76898C8.901 2.72198 9.256 2.70898 11.685 2.70898H12.315ZM12.234 4.51098H11.766C9.31 4.51098 8.982 4.52198 7.959 4.56898C6.984 4.61398 6.455 4.77598 6.102 4.91298C5.635 5.09498 5.302 5.31098 4.952 5.66098C4.602 6.01098 4.386 6.34398 4.204 6.81098C4.067 7.16398 3.904 7.69298 3.86 8.66798C3.813 9.69098 3.802 10.019 3.802 12.475V12.943C3.802 15.399 3.813 15.727 3.86 16.75C3.905 17.725 4.067 18.254 4.204 18.607C4.386 19.073 4.603 19.407 4.952 19.757C5.302 20.107 5.635 20.323 6.102 20.505C6.455 20.642 6.984 20.805 7.959 20.849C9.013 20.897 9.329 20.907 12 20.907H12.08C14.677 20.907 14.997 20.897 16.04 20.849C17.016 20.804 17.545 20.642 17.898 20.505C18.364 20.323 18.698 20.107 19.048 19.757C19.398 19.407 19.614 19.074 19.796 18.607C19.933 18.254 20.096 17.725 20.14 16.75C20.188 15.695 20.198 15.38 20.198 12.709V12.629C20.198 10.032 20.188 9.71198 20.14 8.66898C20.095 7.69298 19.933 7.16398 19.796 6.81098C19.6358 6.37655 19.3802 5.98358 19.048 5.66098C18.7254 5.32884 18.3324 5.07324 17.898 4.91298C17.545 4.77598 17.016 4.61298 16.041 4.56898C15.018 4.52198 14.69 4.51098 12.234 4.51098ZM12 7.57398C12.6743 7.57398 13.3421 7.7068 13.9651 7.96486C14.5881 8.22292 15.1542 8.60116 15.631 9.07799C16.1078 9.55482 16.4861 10.1209 16.7441 10.7439C17.0022 11.3669 17.135 12.0346 17.135 12.709C17.135 13.3833 17.0022 14.0511 16.7441 14.6741C16.4861 15.2971 16.1078 15.8631 15.631 16.34C15.1542 16.8168 14.5881 17.195 13.9651 17.4531C13.3421 17.7112 12.6743 17.844 12 17.844C10.6381 17.844 9.33201 17.303 8.36901 16.34C7.40601 15.377 6.865 14.0709 6.865 12.709C6.865 11.3471 7.40601 10.041 8.36901 9.07799C9.33201 8.11499 10.6381 7.57398 12 7.57398ZM12 9.37598C11.116 9.37598 10.2683 9.72714 9.64321 10.3522C9.01815 10.9773 8.667 11.825 8.667 12.709C8.667 13.593 9.01815 14.4407 9.64321 15.0658C10.2683 15.6908 11.116 16.042 12 16.042C12.884 16.042 13.7317 15.6908 14.3568 15.0658C14.9818 14.4407 15.333 13.593 15.333 12.709C15.333 11.825 14.9818 10.9773 14.3568 10.3522C13.7317 9.72714 12.884 9.37598 12 9.37598ZM17.338 6.17098C17.6563 6.17098 17.9615 6.29741 18.1865 6.52246C18.4116 6.7475 18.538 7.05272 18.538 7.37098C18.538 7.68924 18.4116 7.99447 18.1865 8.21951C17.9615 8.44456 17.6563 8.57098 17.338 8.57098C17.0197 8.57098 16.7145 8.44456 16.4895 8.21951C16.2644 7.99447 16.138 7.68924 16.138 7.37098C16.138 7.05272 16.2644 6.7475 16.4895 6.52246C16.7145 6.29741 17.0197 6.17098 17.338 6.17098Z"
      fill="#9CA3AF"
    />
  </svg>
);

export const Tiktok = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"
      fill="#9CA3AF"
    />
  </svg>
);

export const LinkedIn = (
  <svg
    fill="#9CA3AF"
    width="24"
    height="25"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 310 310"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {" "}
      <g id="XMLID_801_">
        {" "}
        <path
          id="XMLID_802_"
          d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73 C77.16,101.969,74.922,99.73,72.16,99.73z"
        />{" "}
        <path
          id="XMLID_803_"
          d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4 c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
        />{" "}
        <path
          id="XMLID_804_"
          d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599 c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319 c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995 C310,145.43,300.549,94.761,230.454,94.761z"
        />{" "}
      </g>{" "}
    </g>
  </svg>
);

export const Youtube = (
  <svg
    width="24"
    height="25"
    viewBox="0 -0.5 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.168 19.0028C20.4724 19.0867 22.41 17.29 22.5 14.9858V9.01982C22.41 6.71569 20.4724 4.91893 18.168 5.00282H6.832C4.52763 4.91893 2.58998 6.71569 2.5 9.01982V14.9858C2.58998 17.29 4.52763 19.0867 6.832 19.0028H18.168Z"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{" "}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.008 9.17784L15.169 11.3258C15.3738 11.4454 15.4997 11.6647 15.4997 11.9018C15.4997 12.139 15.3738 12.3583 15.169 12.4778L12.008 14.8278C11.408 15.2348 10.5 14.8878 10.5 14.2518V9.75184C10.5 9.11884 11.409 8.77084 12.008 9.17784Z"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{" "}
    </g>
  </svg>
);
